module.exports = "/_next/static/images/de2e425e04b5c2f49034a3410c4cc3fd-savings-perks.gif";